<template>

    <div class="dd-m-filter__col dd-m-filter__col--filter">
        <button v-on:click="openFilter()" type="button" class="dd-m-filter__btns dd-m-filter__btns--filter">
            <i class="dd-m-icon icon-filter"></i>
            <span class="dd-m-filter__btns__text">Filter</span>
        </button>
    </div>

</template>
<script>
    export default {
        name: 'sort-filter',
        methods: {
            openFilter: () => {
                PubSub.publish('toggleFilterMenu');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/filters/attributes-filter.vue